import type { TFunction } from 'i18next'
import { z } from 'zod'

export const getSupplierPaymentFormSchema = (t: TFunction) => {
  const dateRequiredMessage = t('suppliers.detail.payment.validation.date_required')
  // eslint-disable-next-line @typescript-eslint/naming-convention -- zod's error option keys are snake_case
  const dateRequired = { invalid_type_error: dateRequiredMessage, required_error: dateRequiredMessage }

  return z.object({
    accountId: z.string().min(1, t('suppliers.detail.payment.validation.account_required')),
    amount: z.number().positive(t('suppliers.detail.payment.validation.amount_positive')),
    entryDate: z.date(dateRequired),
  })
}
